import { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import useTranslation from "@/hooks/useTranslation";
import Widget from "../../components/Widget/Widget";
import { ImpactMetric } from "../../utils/types";
import { usePackagingImpactPerType } from "@/pages/dashboard/hooks/usePackagingImpact";

export default function PackagingImpactPerType({ metric }: { metric: ImpactMetric }) {
  const translation = useTranslation();
  const { data, isLoading, isFetching } = usePackagingImpactPerType({ metric: metric.key });

  const chartData: DonutChartData =
    data && data?.length > 0 && data?.some((row) => row.impact)
      ? data?.map((row) => ({
          label: row.label,
          value: row.impact?.[metric.key] || 0,
        }))
      : [];

  return (
    <Widget
      title={"Product vs logistics packaging impact"}
      tooltip={translation["dashboard"]["packaging"]["compare"]}
    >
      <SingleBarChart
        colorPalette="ordinal_green"
        data={chartData}
        format={metric.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}
